<template>
  <div class="home">
    <div class="sy-content1">
      <ZYJHZYHD :downloadUrl="downloadUrl" :urlPath="urlPath"></ZYJHZYHD>
      <Subject></Subject>
    </div>
    <div class="wid-1200">
      <Theory></Theory>
      <!-- 学习视频 -->
      <StudyVideo
        :isWeb="isWeb"
        :v_type="v_type"
        :downloadUrl="downloadUrl"
        :urlPath="urlPath"
      ></StudyVideo>
      <AtlasAndOriginal :downloadUrl="downloadUrl"></AtlasAndOriginal>
    </div>
    <PartyBuilding :downloadUrl="downloadUrl"></PartyBuilding>
    <HistoryStudy></HistoryStudy>
    <Inheritance :downloadUrl="downloadUrl"></Inheritance>
    <Regulations></Regulations>
    <ClassRoom :isSYKT="true"></ClassRoom>

  </div>
</template>
<script>
import ZYJHZYHD from "./Home/ZYJHZYHD.vue";
import StudyVideo from "./Home/StudyVideo.vue";
// import Subject from "./Home/Subject.vue"; // 外网
// import Subject from "./Home/Subject1.vue"; // 内网
import Subject from "./Home/Subject3.vue"; // 内网2
import Theory from "./Home/Theory.vue";
import AtlasAndOriginal from "./Home/Atlas.vue";
import Regulations from "./Home/Regulations.vue";
import ClassRoom from "./Home/ClassRoom.vue";
import PartyBuilding from "./Home/PartyBuilding.vue";
import HistoryStudy from "./Home/HistoryStudy.vue";
import Inheritance from "./Home/Inheritance.vue";
export default {
  components: {
    ZYJHZYHD,
    StudyVideo,
    Subject,
    Theory,
    AtlasAndOriginal,
    Regulations,
    ClassRoom,
    PartyBuilding,
    HistoryStudy,
    Inheritance,
  },
  data() {
    return {
      codeShow: true, //二维码是否显示
      downloadUrl: this.url.downloadUrl, //查看图片公共链接
      urlPath: this.url.urlPath, //链接路径
      isWeb: this.url.isWeb, //是否为网站版
      v_type: "", //web:网页版 mirror:镜像版
      cur: 1, //视频课程右侧-当前高亮显示的id
    };
  },
  created() {
    /* //获取到localStorage里的值
		this.username = localStorage.getItem("username");
		this.userData.groupid = localStorage.getItem("groupid");
		this.userData.userid = localStorage.getItem("userid");
		this.groupid_list = JSON.parse(
			window.localStorage.getItem("groupid_list")
		); */

    //yes网站版 no镜像版
    //web:网页版 mirror:镜像版
    if (this.isWeb == "yes") {
      this.v_type = "web";
    } else {
      this.v_type = "mirror";
    }
    // this.getVideoDetailData(1);//获取视频详情
  },
  mounted(){
    this.scrollToSection();
  },
  methods: {
    codeShowFun() {
      this.codeShow = false;
    },

    scrollToSection(anchorId) {
      const targetId = anchorId || this.$route.params.id;
      if (!targetId) return;
      this.$nextTick(() => {
        const targetEl = document.getElementById(targetId);
        if (targetEl) {
          targetEl.scrollIntoView();
        }
      });
    },

    //学习著作-镜像版添加ZYDT_
    addCode(path) {
      //"knavi/journal/Detail/DSZJ/ZGDS?NaviID="
      return path.replace(/DSZJ/, "ZYDT_DSZJ");
    },
    //将数据中最后面的分号去掉
    cutAuthorFun(author) {
      // if(author.indexOf(';')>-1){
      // 	return author.substr(0,author.length-1);
      // }else{
      // 	return author;
      // }
      if (author.substring(author.length - 1) == ";") {
        return author.substr(0, author.length - 1);
      } else {
        return author;
      }
    },

    //视频课程切换
    videoFun(id, index) {
      console.log(index);
      this.cur = id;
      this.$refs.carouselBd.setActiveItem(index); //手动切换幻灯片 相应 el-carousel-item 的 name 属性值
      this.getVideoDetailData(id); //获取视频详情
    },
    //获取视频详情
    getVideoDetailData(id, str) {
      //str 用于接收概论survey/方法论methods 进行不同的赋值
      if (!str) {
        this.videoDetailLoading = true; //加载中显示
      }
      this.axios.get("/sqlite/views_list_detail/" + id + "/").then((res) => {
        console.log("获取视频课程详情======" + str);
        console.log(res);
        if (res.status == 200) {
          if (str == "survey") {
            this.videoDetailDataSurvey = res.data;
          } else if (str == "methods") {
            this.videoDetailDataMethods = res.data;
          } else {
            this.videoDetailLoading = false; //加载中隐藏
            this.videoDetailData = res.data;
          }
        } else {
          console.log("获取视频课程详情失败！");
          this.$message.error("获取视频课程详情失败！");
        }
      });
    },
  },
  watch:{
    '$route.params.id': function(newVal,oldVal){
      if(newVal !== oldVal) {
        this.scrollToSection(newVal);
      }
    }
  }
}
</script>
<style lang="scss">
.home{
  padding-bottom: 30px;
}
.el-popover {
  min-width: 140px !important;
  padding: 5px !important;
}
</style>
<style lang="scss" scoped>
.code {
  position: fixed;
  left: 0;
  top: 50%;
  z-index: 50;
  i {
    font-size: 30px;
    position: absolute;
    top: -16px;
    right: -16px;
    z-index: 10;
    cursor: pointer;
  }
}
// .title2 {
// 	background: url("../assets/images/title2.png") bottom 0 no-repeat;
// }
.title3 {
  background: url("../assets/images/title3.png") center bottom no-repeat;
}
// 讲话全文+重要活动
.leader  ::v-deep {
  // 讲话全文
  .leader-t {
    width: 871px;
  }
  .leader-t-con {
    font-size: 16px;
    text-align: justify;
    .con {
      width: 396px;
      .con-title {
        font-size: 16px;
        color: #333;
        padding-bottom: 20px;
      }
      .abstract {
        font-size: 12px;
        color: #888;
        line-height: 28px;
        padding-bottom: 19px;
      }
      .gx_l_data {
        height: 146px;
        overflow: hidden;
        li {
          width: 100%;
          height: 30px;
          line-height: 30px;
          a {
            background: url("../assets/images/arrow-small.png") 0 center
              no-repeat;
            padding-left: 19px;
            font-size: 14px;
            color: #666;
            width: calc(100% - 110px);
            &:hover {
              color: #f70;
            }
          }
          span {
            font-size: 12px;
            color: #666;
          }
        }
      }
    }
  }
  // 重要活动
  .leader-b {
    width: 311px;
    h2 {
      height: 58px;
      line-height: 50px;
      font-size: 28px;
      color: #ac0101;
      background: url("../assets/images/title2.png") 0 bottom no-repeat;
      text-align: center;
    }
    .gx_l_data {
      padding-left: 18px;
      padding-top: 41px;
      height: 346px;
      li {
        width: 100%;
        margin-right: 0;
        line-height: 32px;
        height: 32px;
        font-size: 13px;
        a {
          background: none;
          position: relative;
          padding-left: 15px;
          width: calc(100% - 110px);
          color: #666;
          &:after {
            content: "";
            width: 6px;
            height: 6px;
            background-color: #ec5b00;
            position: absolute;
            top: 50%;
            margin-top: -3px;
            left: 0;
          }
          &:hover {
            color: #f70;
          }
        }
        span {
          font-size: 12px;
        }
      }
    }
  }
  .more {
    text-align: right;
    margin-right: 0 !important;
    a {
      padding-left: 0 !important;
      width: 100% !important;
      background: none !important;
      font-size: 13px !important;
      &:after {
        display: none;
      }
    }
  }
}

::v-deep {
  .gx_l_data {
    li {
      height: 42px;
      line-height: 42px;
      float: left;
      font-size: 14px;
      width: 46%;
      margin-right: 42px;
      a {
        padding-left: 61px;
        color: #333;
        background: url("../assets/images/text-icon.png") 25px center no-repeat;
        width: calc(100% - 200px);
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        float: left;
      }
      span {
        width: 86px;
        color: #666;
        float: right;
        text-align: right;
      }
      & a:hover {
        color: #f70;
      }
    }
  }
}
// .gx_l_data li.item_more{line-height:30px;height:30px;background:none;text-align:right;}
// .gx_l_data li.item_more a{color:#d18c46;display:inline;font-size:20px;width:74px;float:none;}
</style>
